module.exports = __webpack_public_path__ + "static/img/news-cqw.b18e359.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/news-cqw.jpg
// module id = 6LxR
// module chunks = 0